define("shared/components/shared/modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{this.modalClass}} data-test-id="modal" ...attributes>
    <div
      class="o--modalWrapper"
      {{on-escape-key-down this.closeModal}}
      {{focus-trap
        isActive=this.focusTrapActive
      }}
    >
      {{#if this.backdrop}}
        <div
          role="button"
          class="o--modal--close"
          data-test-id="modal-close"
          {{on "click" this.closeModal}}
        ></div>
      {{/if}}
  
      <div class="o--modalVer">
        <div class="o--modalHor">
          <div tabindex="0" aria-modal="true" role="dialog">
            {{yield (hash
                banner=(component "shared/modal/banner")
                card=(component "shared/modal/section" closable=this.closable close=this.closeModal)
                card-header=(component "shared/modal/header")
                card-body=(component "shared/ui/block" tagName="div" primaryClass="o--modalBody")
                card-footer=(component "shared/ui/block" tagName="footer" primaryClass="o--modalFooter")
                close=this.closeModal
              )
            }}
          </div>
        </div>
      </div>
      {{#if @navigate}}
        <Shared::Modal::Navigation @navigate={{@navigate}}/>
      {{/if}}
    </div>
  </div>
  
  */
  {
    "id": "KMI/goE5",
    "block": "[[[11,0],[16,0,[30,0,[\"modalClass\"]]],[24,\"data-test-id\",\"modal\"],[17,1],[12],[1,\"\\n  \"],[11,0],[24,0,\"o--modalWrapper\"],[4,[38,0],[[30,0,[\"closeModal\"]]],null],[4,[38,1],null,[[\"isActive\"],[[30,0,[\"focusTrapActive\"]]]]],[12],[1,\"\\n\"],[41,[30,0,[\"backdrop\"]],[[[1,\"      \"],[11,0],[24,\"role\",\"button\"],[24,0,\"o--modal--close\"],[24,\"data-test-id\",\"modal-close\"],[4,[38,3],[\"click\",[30,0,[\"closeModal\"]]],null],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"o--modalVer\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--modalHor\"],[12],[1,\"\\n        \"],[10,0],[14,\"tabindex\",\"0\"],[14,\"aria-modal\",\"true\"],[14,\"role\",\"dialog\"],[12],[1,\"\\n          \"],[18,3,[[28,[37,5],null,[[\"banner\",\"card\",\"card-header\",\"card-body\",\"card-footer\",\"close\"],[[50,\"shared/modal/banner\",0,null,null],[50,\"shared/modal/section\",0,null,[[\"closable\",\"close\"],[[30,0,[\"closable\"]],[30,0,[\"closeModal\"]]]]],[50,\"shared/modal/header\",0,null,null],[50,\"shared/ui/block\",0,null,[[\"tagName\",\"primaryClass\"],[\"div\",\"o--modalBody\"]]],[50,\"shared/ui/block\",0,null,[[\"tagName\",\"primaryClass\"],[\"footer\",\"o--modalFooter\"]]],[30,0,[\"closeModal\"]]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"      \"],[8,[39,7],null,[[\"@navigate\"],[[30,2]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"&attrs\",\"@navigate\",\"&default\"],false,[\"on-escape-key-down\",\"focus-trap\",\"if\",\"on\",\"yield\",\"hash\",\"component\",\"shared/modal/navigation\"]]",
    "moduleName": "shared/components/shared/modal.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::Modal
   * @extends Component
   */
  let Modal = (_class = class Modal extends _component2.default {
    get focusTrapActive() {
      var _this$args$focusTrap;

      return (_this$args$focusTrap = this.args.focusTrap) !== null && _this$args$focusTrap !== void 0 ? _this$args$focusTrap : false;
    }
    /**
     * Defines whether or not the modal can be closed
     *
     * @property closable
     * @type {Boolean}
     * @default true
     */


    get closable() {
      var _this$args$closable;

      if (this.args.inline) {
        return false;
      }

      return (_this$args$closable = this.args.closable) !== null && _this$args$closable !== void 0 ? _this$args$closable : true;
    }
    /**
     *  * Includes a modal close element in the background
     *
     * @property backdrop
     * @type {Boolean}
     * @default true
     */


    get backdrop() {
      var _this$args$backdrop;

      if (this.args.inline) {
        return false;
      }

      return (_this$args$backdrop = this.args.backdrop) !== null && _this$args$backdrop !== void 0 ? _this$args$backdrop : true;
    }
    /**
     * @property modalClass
     * @type {String}
     * @default 'o--modalBg'
     */


    get modalClass() {
      var _this$args$primaryCla;

      const fallbackClass = !this.backdrop || this.args.inline ? 'o--modalBg--inner' : 'o--modalBg';
      return (_this$args$primaryCla = this.args.primaryClass) !== null && _this$args$primaryCla !== void 0 ? _this$args$primaryCla : fallbackClass;
    }
    /**
     * Closes the modal if 'closable' and a valid 'close' function exists
     *
     * @method closeModal
     */


    closeModal() {
      if (this.closable && typeof this.args.close === 'function') {
        this.args.close();
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class);
  _exports.default = Modal;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Modal);
});